<script setup>
import EmailIcon from "../../components/icons/EmailIcon.vue";

const router = useRouter();

const form = ref({
  token: null,
  name: "",
  email: "",
  message: "",
});

const processing = ref(false);

const handleSubmit = async () => {
  processing.value = true;
  const response = await $fetch("/api/contact", {
    method: "POST",
    body: form.value,
  });

  if (response.success) {
    // Form submitted successfully
    router.push("/contact/success");
  } else {
    // Handle error case
    console.error("Form submission failed");
  }
  processing.value = false;
};
</script>

<template>
  <div class="gap-12 sm:flex">
    <div class="sm:w-1/4">
      <h2 class="pb-2 text-2xl">Wanna talk to Kate?</h2>

      <div class="bg-green mb-6 h-2 w-40 md:w-60" />

      <p class="pb-8 font-serif text-xl lg:pb-16">
        Would you like to purchase a piece you saw or commission one of your own? <br />

        <br />
        Let me know here!
      </p>
    </div>

    <form class="bg-ice px-4 py-6 lg:px-10" @submit.prevent="handleSubmit">
      <div class="grid grid-cols-3">
        <label
          class="text-cerulean border-r-2 border-b-2 border-white py-3 pr-3 text-right font-normal md:text-2xl"
          for="name"
        >
          Your Name
        </label>

        <input
          id="name"
          v-model="form.name"
          placeholder="Kermit LeFrog"
          type="text"
          class="bg-ice col-span-2 border-b-2 border-white pl-3 md:text-xl"
          name="name"
        />

        <label
          for="email"
          class="text-cerulean border-r-2 border-b-2 border-white py-3 pr-3 text-right font-normal md:text-2xl"
        >
          Email Address
        </label>

        <input
          id="email"
          v-model="form.email"
          placeholder="kermit@themuppets.com"
          name="email"
          type="email"
          class="bg-ice col-span-2 border-b-2 border-white pl-3 md:text-xl"
          required
        />

        <label
          for="message"
          class="text-cerulean border-r-2 border-b-2 border-white py-3 pr-3 text-right font-normal md:text-2xl"
          required
        >
          Message
        </label>

        <textarea
          id="message"
          v-model="form.message"
          placeholder="Hi ho there, Kermit LeFrog here..."
          name="message"
          class="bg-ice col-span-2 border-b-2 border-white p-3 md:text-xl"
          rows="6"
          required
        />
      </div>

      <div class="flex flex-col items-center justify-between pt-5 lg:flex-row">
        <NuxtTurnstile v-model="form.token" />

        <div class="flex items-center justify-end">
          <button
            :disabled="!form.token || processing"
            class="text-cerulean hover:bg-ice-400 active:bg-ice-600 flex items-center gap-3 px-5 py-3 text-2xl font-normal hover:rounded-sm disabled:text-gray-400 disabled:hover:bg-gray-200"
            type="submit"
          >
            <span>Send</span>
            <LoadingSpinner v-if="processing" class="inline h-8" />
            <EmailIcon v-else class="inline h-8" />
          </button>
        </div>
      </div>
    </form>
  </div>
</template>
